import { render, staticRenderFns } from "./AddQuiz.vue?vue&type=template&id=6d223650&scoped=true&"
import script from "./AddQuiz.vue?vue&type=script&lang=js&"
export * from "./AddQuiz.vue?vue&type=script&lang=js&"
import style0 from "./AddQuiz.vue?vue&type=style&index=0&id=6d223650&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d223650",
  null
  
)

export default component.exports